module.exports = __webpack_public_path__ + "img/服务流程8.3737f726.png";